import React, { useEffect } from 'react';
import globalHook, { Store } from 'use-global-hook';

type BackUrl = string | null | ((...args: any[]) => string | null);

type BackUrlState = {
  backUrl: BackUrl;
};

const initialState: BackUrlState = {
  backUrl: null,
};

type BackUrlActions = {
  setBackUrl: (backUrl: BackUrl) => void;
};

const actions = {
  setBackUrl: (store: Store<BackUrlState, BackUrlActions>, backUrl) => {
    store.setState({ backUrl });
  },
};

const useGlobalBackUrl = globalHook<BackUrlState, BackUrlActions>(React, initialState, actions);

const useBackUrl = (initBackUrl: BackUrl = null) => {
  const [backUrl, setBackUrl] = useGlobalBackUrl();
  useEffect(() => {
    if (initBackUrl) {
      setBackUrl.setBackUrl(initBackUrl);
    }
  }, [initBackUrl]);

  // reset on unmount? - Another reason to move to context or redux
  // useEffect( () => () => setBackUrl.setBackUrl(null), [] );

  return {
    backUrl: backUrl.backUrl,
    setBackUrl: setBackUrl.setBackUrl,
  };
};

export default useBackUrl;
